<div class="page-wrapper">
    <div class="container login-container">
        <div class="login-page">
            <div class="login-left">
                <h1>{{ 'The environmental management platform for heavy industrial companies' | translate }}</h1>
                <h6>{{ 'We reduce health and environmental risks by combining real-time dust sensors with intelligent air quality software.' | translate }}</h6>
                <div class="ripple">
                    <img src="../../../assets/images/ripple-bg.png">
                </div>
            </div>
            <div class="login-right">
                <div class="login-form">
                    <div class="d-flex justify-content-between">
                        <div class="logo-form">
                            <img src="../../../assets/images/new-logo.png">
                        </div>
                        <app-language-switcher></app-language-switcher>
                    </div>

                    <br />
                    <br />
                    <br />
                    <span class="Log-in-to-your-accou">
                        {{ 'Please enter your username to continue' | translate }}
                    </span>
                    <form class="mt-2" [formGroup]="form" (ngSubmit)="submit()">
                        <div class="form-group">
                            <input type="text" formControlName="username" placeholder="{{ 'Email ID' | translate }}" class="form-control">
                            <span class="form-control-icon"><img src="assets/images/account_circle.png"></span>
                        </div>
                        <div class="form-group button-section">
                            <input type="button" (click)="backToLogin()" class="cancel-btn" value="{{ 'Cancel' | translate }}">
                            <input type="submit" value="{{ 'Continue' | translate }}">
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <footer>
            <div class="container ml-2">
                <p><app-copyright></app-copyright></p>
            </div>
        </footer>
    </div>
</div>
